import router from '@/router'

export default function vuexRouterInterceptor() {
  return (store) => {
    store.commit('initStore')
    store.commit('initLang')
    router.beforeEach((to, from, next) => {
      console.debug(to)
      if (!localStorage.getItem('userInfo') && to.name !== 'Login') {
        next({ name: 'Login' })
      } else {
        store.dispatch('trackerLog', {
          event: 'route_view',
          message: {
            page: `${to.name}_Page`,
          },
        })
        next()
      }
    })
  }
}
